(function(){
  angular
      .module('scroll-into.dir', ['journey.canvas.srv', 'journey.veil'])
	  .directive('scrollInto', function () {
		return function(scope, element, attrs) {
			scope.$watch(attrs.scrollInto, function(value) {
				if (value) {
					element[0].scrollIntoView({ block: 'end', behavior: 'smooth' });
				}
			});
		};
	});
}());



// WEBPACK FOOTER //
// ./app/directives/canvas_directives/scroll-into.js